import React, { useState } from 'react';

import { Tab, Tabs } from 'react-bootstrap';

import Container from 'components/shared/Container';
import ProductsWithASaleIn1MAndUnstructuredView from 'components/enrich/ProductsWithASaleIn1MAndUnstructuredView.jsx';
import UnbrandedProductsView from 'components/enrich/unstructured_view/UnbrandedProductsView.jsx';

const UNSTRUCTURED_TABS = {
  UNSTRUCTURED_PRODUCTS: 'Unstructured Products',
  UNBRANDED_PRODUCTS: 'Unbranded Products',
};

function UnstructuredTabView() {
  const [activeTabKey, setActiveTabKey] = useState(UNSTRUCTURED_TABS.UNSTRUCTURED_PRODUCTS);
  return (
    <Container>
      <Tabs
        className="mt-1 border-top-0"
        defaultActiveKey={activeTabKey}
        onSelect={selectedKey => setActiveTabKey(selectedKey)}
        transition={false}
        mountOnEnter
        unmountOnExit
      >
        <Tab
          eventKey={UNSTRUCTURED_TABS.UNSTRUCTURED_PRODUCTS}
          title={UNSTRUCTURED_TABS.UNSTRUCTURED_PRODUCTS}
        >
          <ProductsWithASaleIn1MAndUnstructuredView />
        </Tab>
        <Tab
          eventKey={UNSTRUCTURED_TABS.UNBRANDED_PRODUCTS}
          title={UNSTRUCTURED_TABS.UNBRANDED_PRODUCTS}
        >
          <UnbrandedProductsView />
        </Tab>
      </Tabs>
    </Container>
  );
}

export default UnstructuredTabView;
